import {analyticsLogEvent} from '../api'
import {ProductImpression} from '_types'

const eventName = 'productClick'

interface ActionField {
    list: string
}

interface Click {
    actionField: ActionField
    products: Omit<ProductImpression, 'list'>[]
}

interface Ecommerce {
    currencyCode: string
    dimension25?: string
    click: Click
}

interface EventDetails {
    ecommerce: Ecommerce
}

/**
 * Tracks a product click event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.currencyCode - Currency code of the product.
 * @param {ActionField} params.actionField - Action field parameter.
 * @param {Product} params.product - Product parameter.
 */
export function analyticsProductClick({
    currencyCode,
    dimension25 = undefined,
    actionField,
    product,
}: {
    currencyCode: string
    dimension25?: string
    actionField: ActionField
    product: Omit<ProductImpression, 'list'>
}) {
    const eventDetails: EventDetails = {
        ecommerce: {
            currencyCode: currencyCode,
            dimension25: dimension25,
            click: {
                actionField: actionField,
                products: [product],
            },
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
